import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import LogoEU from './../images/logo-eu-inverted.svg';

const messages = defineMessages({
  logo_eu: {
    id: 'logo_eu',
    defaultMessage: "Finanziato dall'Unione Europea - Next Generation EU",
  },
});

const LogoFooterEU = () => {
  const intl = useIntl();
  return (
    <div className="logo-eu-wrap">
      <img src={LogoEU} alt={intl.formatMessage(messages.logo_eu)} />
    </div>
  );
};

export default LogoFooterEU;
